import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isChallengesShortText(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CHALLENGES_SHORT_TEXT && typeof label === 'string' && typeof value === 'string';
}
function _formatChallengesShortText(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return undefined;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatChallengesShortText(submission) {
  if (isChallengesShortText(submission)) {
    return _formatChallengesShortText(submission);
  }
  return undefined;
}
//# sourceMappingURL=challenges-short-text-preview.js.map